import { useDispatch } from "react-redux";
import Button from "@shared/v2/Button";
import Modal from "@shared/v2/Modal";
import TextLink from "@shared/v2/TextLink";
import Typography from "@shared/v2/Typography";
import { ArrowRightSolidV6 } from "@shared/v2/Icomoon";
import { useFirstPostModalOpen } from "../../reducers/websiteReducer/selectors";
import { setFirstPostModalOpen } from "../../reducers/websiteReducer/websiteReducer";

const FirstPostModal = () => {
  const dispatch = useDispatch();
  const firstPostModalOpen = useFirstPostModalOpen();

  return (
    <Modal
      show={firstPostModalOpen}
      dialogClassName="tw-flex tw-items-center tw-justify-center tw-h-full"
      contentClassName="tw-max-w-[460px] tw-max-h-[90vh] tw-w-full tw-flex tw-flex-col tw-gap-[32px]"
    >
      <Modal.Header title="Congratulations on publishing your first Brivity blog post! 🎉" />
      <Modal.Body className="tw-flex tw-flex-col tw-gap-[24px]">
        <Typography>
          Blogging is a powerful way to showcase your expertise, attract potential clients, and boost your
          website’s visibility in search results. Consistently sharing valuable insights can help you build
          trust and grow your real estate business.
        </Typography>
        <Typography>
          If blogs haven’t been set up on your site yet, please{" "}
          <TextLink
            schema="sentence"
            size="medium"
            onClick={(e) => {
              e.preventDefault();
              if (typeof window.Intercom === "function") {
                window.Intercom("show");
              }
            }}
          >
            start a chat with support
          </TextLink>
          . We’re happy to help!
        </Typography>
      </Modal.Body>
      <Modal.Footer>
        <Button
          size="medium"
          className="tw-flex tw-justify-center tw-items-center tw-gap-[4px] tw-w-full"
          onClick={() => {
            dispatch(setFirstPostModalOpen(false));
          }}
        >
          Awesome! Let’s keep going <ArrowRightSolidV6 />
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default FirstPostModal;
